import { t as gsapWithCSS } from "@theme/gsap";
import { n as ensureSplitText, t as ensureScrollTrigger } from "@theme/gsap-utils";
//#region frontend/islands/story-step-text.js
var StoryStepText = class extends HTMLElement {
	async connectedCallback() {
		const [ScrollTrigger, SplitText] = await Promise.all([ensureScrollTrigger(), ensureSplitText()]);
		this.label = this.querySelector(".story__step-label");
		this._title = this.querySelector(".story__step-title");
		this.body = this.querySelector(".story__step-body");
		this.highlightList = this.querySelector(".story__step-highlights");
		this.highlights = gsapWithCSS.utils.toArray(this.highlightList.querySelectorAll("li"));
		this.splitLabel = SplitText.create(this.label, {
			type: "words",
			aria: false
		});
		this.splitBody = SplitText.create(this.body, {
			type: "lines",
			aria: false
		});
		gsapWithCSS.set([
			this.label,
			this._title,
			this.body,
			this.highlightList
		], { autoAlpha: 1 });
		gsapWithCSS.set([
			this.splitLabel.words,
			this._title,
			this.splitBody.lines,
			[...this.highlights]
		], {
			x: -10,
			opacity: 0
		});
		let sequence = 0;
		let highlightSequence = 0;
		let lastTriggerTime = 0;
		let bodyEndsAt = 0;
		const WINDOW_MS = 600;
		const lines = this.splitBody.lines.length;
		const bodyLineInterval = lines > 1 ? .2 / (lines - 1) : .2;
		const onEnter = (targets, options = {}) => {
			const now = performance.now();
			if (now - lastTriggerTime > WINDOW_MS) sequence = 0;
			lastTriggerTime = now;
			gsapWithCSS.to(targets, {
				x: 0,
				opacity: 1,
				delay: sequence++ * bodyLineInterval,
				...options
			});
		};
		this._triggers = [];
		this._triggers.push(ScrollTrigger.create({
			trigger: this.label,
			onEnter: () => onEnter(this.splitLabel.words, {
				stagger: { amount: .2 },
				onComplete: () => this.splitLabel.revert()
			})
		}));
		this._triggers.push(ScrollTrigger.create({
			trigger: this._title,
			onEnter: () => onEnter(this._title)
		}));
		this._triggers.push(ScrollTrigger.create({
			trigger: this.body,
			onEnter: () => {
				const now = performance.now();
				if (now - lastTriggerTime > WINDOW_MS) sequence = 0;
				lastTriggerTime = now;
				const delay = sequence++ * bodyLineInterval;
				bodyEndsAt = now + (delay + .2 + bodyLineInterval) * 1e3;
				gsapWithCSS.to(this.splitBody.lines, {
					x: 0,
					opacity: 1,
					delay,
					stagger: { amount: .2 },
					onComplete: () => this.splitBody.revert()
				});
			}
		}));
		this.highlights.forEach((highlight) => {
			this._triggers.push(ScrollTrigger.create({
				trigger: highlight,
				onEnter: () => {
					const now = performance.now();
					if (now - lastTriggerTime > WINDOW_MS) {
						sequence = 0;
						highlightSequence = 0;
					}
					lastTriggerTime = now;
					sequence++;
					const bodyWait = Math.max(0, (bodyEndsAt - now) / 1e3);
					gsapWithCSS.to(highlight, {
						x: 0,
						opacity: 1,
						delay: bodyWait + highlightSequence++ * bodyLineInterval
					});
				}
			}));
		});
	}
	disconnectedCallback() {
		this._triggers?.forEach((t) => t.kill());
		this.splitLabel?.revert();
		this.splitBody?.revert();
	}
};
window.customElements.define("story-step-text", StoryStepText);
//#endregion
